module.exports = __webpack_public_path__ + "media/pricing/Business-abb0d003.png";